import { NotFound } from '@stratumn/atomic';

import { ROUTE_ORG } from 'constant/routes';
import compose from 'lodash.flowright';
import PropTypes from 'prop-types';
import React from 'react';
import injectSheet from 'react-jss';
import { withRouter } from 'react-router-dom';

import styles from './notFound.style';

export const NotFoundPage = ({ history }) => {
  const goToHome = React.useCallback(() => {
    history.push(ROUTE_ORG);
  }, [history]);
  return <NotFound onHomeClick={goToHome} />;
};

NotFoundPage.propTypes = {
  history: PropTypes.object.isRequired
};

export default compose(withRouter, injectSheet(styles))(NotFoundPage);
